export enum LootboxTabs {
  buy,
  owned,
}
